import React, { Component } from 'react';
import './Masthead.scss';
import TextLockup from '../../components/TextLockup';
import Nav from '../../components/Nav';
import Logo from '../../components/Logo';

const videos = {
    short: {
        webm: 'https://res.cloudinary.com/djmob5zwj/video/upload/ac_none/v1556190107/daimler/dtna-short.webm',
        mp4: 'https://res.cloudinary.com/djmob5zwj/video/upload/ac_none/v1556190107/daimler/dtna-short.mp4'
    },
    full: {
        mp4: 'https://res.cloudinary.com/djmob5zwj/video/upload/v1556233428/daimler/dtna.mp4',
        webm: 'https://res.cloudinary.com/djmob5zwj/video/upload/v1556233428/daimler/dtna.webm'
    },
    full_: {
        mp4: 'https://res.cloudinary.com/djmob5zwj/video/upload/v1556191026/daimler/dtna-full.mp4',
        webm: 'https://res.cloudinary.com/djmob5zwj/video/upload/v1556191026/daimler/dtna-full.webm'
    }
}

class Masthead extends Component {
    
    state = {
        intro: true
    }

    onLearnClick = () => {

    }

    onWatchClick = () => {
        this.setState({intro:false});
    }

    onVideoClose = () => {
        this.setState({intro:true});
    }

    render() {
        const { id } = this.props;
        
    
        return (
            <div className="Masthead" id={id}>

                {
                    this.state.intro === true 
                
                    ?
                    
                        <React.Fragment>

                            <Logo/>

                            <video className="inline-video" width="100%" loop autoPlay="autoplay" muted={true} playsInline="yes" preload="auto">
                                <source src={videos.short.webm} type={`video/webm`} />
                                <source src={videos.short.mp4} type={`video/mp4`} />
                            </video>

                            <TextLockup 
                                onLearnClick={this.onLearnClick}
                                onWatchClick={this.onWatchClick}
                            />

                            <Nav/>
                        </React.Fragment>

                    :

                        <React.Fragment>

                            <div className="video">
                                <video className="inline-video-full" width="100%" height="100%" loop autoPlay="autoplay" muted={false} playsInline="yes" preload="auto">
                                    <source src={videos.full.webm} type={`video/webm`} />
                                    <source src={videos.full.mp4} type={`video/mp4`} />
                                </video>
                            </div>

                            <Nav 
                                close={true} 
                                onClose={this.onVideoClose}
                            />
                        </React.Fragment>

                    
                }


                
                
                
            </div>
        );
    }
}

export default Masthead;